'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_components_AppMainModal$Data() {
}
export { $c_Lapp_components_AppMainModal$Data as $c_Lapp_components_AppMainModal$Data };
$c_Lapp_components_AppMainModal$Data.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_components_AppMainModal$Data.prototype.constructor = $c_Lapp_components_AppMainModal$Data;
/** @constructor */
function $h_Lapp_components_AppMainModal$Data() {
}
export { $h_Lapp_components_AppMainModal$Data as $h_Lapp_components_AppMainModal$Data };
$h_Lapp_components_AppMainModal$Data.prototype = $c_Lapp_components_AppMainModal$Data.prototype;
$c_Lapp_components_AppMainModal$Data.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=app.components.-App-Main-Modal$-Data.js.map
